export default __webpack_public_path__ + "static/speedy9-4e81cb0df60c677dfa166cd5e67388fa.svg";